/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getReferrals } from 'app/entities/referral/referral.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getTumorBoardOccurrences } from 'app/entities/tumor-board-occurrence/tumor-board-occurrence.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-referral.reducer';

export const TumorBoardReferralUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const referrals = useAppSelector(state => state.referral.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const tumorBoardOccurrences = useAppSelector(state => state.tumorBoardOccurrence.entities);
  const tumorBoardReferralEntity = useAppSelector(state => state.tumorBoardReferral.entity);
  const loading = useAppSelector(state => state.tumorBoardReferral.loading);
  const updating = useAppSelector(state => state.tumorBoardReferral.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardReferral.updateSuccess);

  const handleClose = () => {
    navigate(`/tumor-board-referral${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getReferrals({}));
    dispatch(getGlucoUsers({}));
    dispatch(getTumorBoardOccurrences({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardReferralEntity,
      ...values,
      referral: referrals.find(it => it.id.toString() === values.referral?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      occurrence: tumorBoardOccurrences.find(it => it.id.toString() === values.occurrence?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tumorBoardReferralEntity,
          referral: tumorBoardReferralEntity?.referral?.id,
          patient: tumorBoardReferralEntity?.patient?.id,
          occurrence: tumorBoardReferralEntity?.occurrence?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorBoardReferral.home.createOrEditLabel" data-cy="TumorBoardReferralCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.home.createOrEditLabel">
              Create or edit a TumorBoardReferral
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-referral-id"
                  label={translate('tinyMedicRestApp.tumorBoardReferral.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardReferral.active')}
                id="tumor-board-referral-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardReferral.cursor')}
                id="tumor-board-referral-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardReferral.lastUpdated')}
                id="tumor-board-referral-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardReferral.microSec')}
                id="tumor-board-referral-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardReferral.timestampEntry')}
                id="tumor-board-referral-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-referral-referral"
                name="referral"
                data-cy="referral"
                label={translate('tinyMedicRestApp.tumorBoardReferral.referral')}
                type="select"
              >
                <option value="" key="0" />
                {referrals
                  ? referrals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-referral-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.tumorBoardReferral.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-referral-occurrence"
                name="occurrence"
                data-cy="occurrence"
                label={translate('tinyMedicRestApp.tumorBoardReferral.occurrence')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardOccurrences
                  ? tumorBoardOccurrences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-board-referral" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardReferralUpdate;
